import React, { Component } from 'react';
import classNames from 'classnames';

class Timeline extends Component {
  constructor(props) {
    super(props);
    this.totalSteps = this.props.totalSteps + 2;
    this.stepHeight = 100 / this.totalSteps;
  }
  render() {
    const { className, currentStep } = this.props;
    return (
      <div className={`timeline ${className}`}>
        <div className="timeline__progress">
          <div
            className="timeline__progress-inner"
            style={{
              height: `${this.stepHeight + (this.stepHeight * (currentStep + 1))}%`
            }}
          />
        </div>
        <ul className="timeline__steps">
          <li
            className="timeline__step"
            style={{ height: `${this.stepHeight}%` }}
          />
          {this.props.steps.map((step, i) =>
            <li
              className={classNames(
                'timeline__step',
                { 'timeline__step--active': i === currentStep }
              )}
              key={i}
              style={{ height: `${this.stepHeight}%` }}
            >
              <div className="timeline__step-number">{step}</div>
            </li>
          )}
          <li
            className="timeline__step"
            style={{ height: `${this.stepHeight}%` }}
          />
        </ul>
      </div>
    );
  }
}

export default Timeline;



/** WEBPACK FOOTER **
 ** ./src/js/components/timeline.js
 **/